import { render } from "./catalog.cattle.io.clusterrepo.vue?vue&type=template&id=49332dfe&scoped=true&ts=true"
import script from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=ts"
export * from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=ts"

import "./catalog.cattle.io.clusterrepo.vue?vue&type=style&index=0&id=49332dfe&lang=css&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49332dfe"]])

export default __exports__